import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import {
  productFilterOptionAdapter,
  updateManyProductFilterOptions,
} from "@/lib/redux/productFilters/productFiltersSlice";
import {
  productFilterOptionSelectors,
  productFilterSelectors,
} from "@/lib/redux/store";
import { useCallback } from "react";
import { Container, PrimaryButton, SecondaryButton } from "./styles";
import { useRouter } from "next/router";
import { useTranslation } from "@/lib/translations";

type Props = {
  handleClose: () => void;
  totalHits: number;
};

const Footer: React.FC<Props> = (props) => {
  const { handleClose, totalHits } = props;

  const { locale = "it" } = useRouter();
  const t = {
    removeAll: useTranslation("filters.removeAll", locale) || "",
    productsCounter: useTranslation("productListing.productsCounter", locale) || "",
    productsCounterOne: useTranslation("productListing.productsCounterOne", locale) || "",
  };
  const labelProductCounter = (totalHits === 1) ? t.productsCounterOne : t.productsCounter
  const dispatch = useAppDispatch();

  const filters = useAppSelector((state) =>
    productFilterSelectors.selectAll(state)
  );

  const unselectAllFilterOptions = useCallback(() => {
    filters.forEach((filter) => {
      const optionIds = productFilterOptionSelectors.selectIds(filter);
      dispatch(
        updateManyProductFilterOptions({
          filterId: filter.id,
          updates: optionIds.map((id) => ({
            id,
            changes: {
              selected: false,
            },
          })),
        })
      );
    });
  }, [dispatch, filters]);

  return (
    <Container>
      <SecondaryButton
        onClick={() => {
          unselectAllFilterOptions();
          handleClose();
        }}
      >
        {t.removeAll}
      </SecondaryButton>
      <PrimaryButton onClick={handleClose}>{totalHits} {labelProductCounter}</PrimaryButton>
    </Container>
  );
};

export default Footer;
